import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class Orc extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'orc')
    
    this.maxHealth = 80
    this.health = 80
    this.damage = PLAYER_DAMAGE.STANDARD
    this.moveSpeed = 3
    this.attackRange = 1.5
    this.attackCooldown = 2
    this.detectionRange = 14
    this.knockbackResistance = 0.5
  }
  
  dropLoot() {
    if (Math.random() < 0.3) {
      this.game.itemManager.spawnItem({
        type: 'sword',
        id: 'stone_sword',
        name: 'Stone Sword',
        damage: 15,
        count: 1
      }, { x: this.x, y: this.y })
    }
    
    if (Math.random() < 0.5) {
      this.game.itemManager.spawnItem({
        type: 'food',
        id: 'cooked_meat',
        name: 'Cooked Meat',
        hungerRestore: 40,
        count: 1
      }, { x: this.x, y: this.y })
    }
    
    if (Math.random() < 0.5) {
      this.game.itemManager.spawnItem({
        type: 'block',
        id: 'wood',
        name: 'Wood',
        blockType: 4,
        count: 3 + Math.floor(Math.random() * 4)
      }, { x: this.x, y: this.y })
    }
  }
}
